import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";

export const Field = styled.div<{ $error: boolean; $disabled: boolean }>`
  display: flex;
  width: 100%;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing[2]};
  padding: ${spacing[2]} ${spacing[3]};
  border: 1px solid
    ${({ $error }) => ($error ? rawColors.accent.pink : rawColors.stroke[200])};
  border-radius: ${borderRadius.md};
  background-color: ${rawColors.structural.white};
  min-height: 42px;
  box-sizing: border-box;
  opacity: ${({ $disabled }) => ($disabled ? 0.64 : 1)};

  &:focus-within {
    border-color: ${({ $error }) =>
      $error ? rawColors.accent.pink : rawColors.primary[500]};
  }
`;

export const Chip = styled.span`
  display: inline-flex;
  min-width: 0;
  max-width: 100%;
  align-items: center;
  gap: ${spacing[1]};
  padding: 2px ${spacing[2]};
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  background-color: ${rawColors.structural[100]};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.sm};
`;

export const ChipLabel = styled.span`
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const ChipRemove = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  color: ${rawColors.text.mediumEmphasis};
  cursor: pointer;
  padding: 0;
  &:hover {
    color: ${rawColors.text.highEmphasis};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const Input = styled.input`
  flex: 1;
  min-width: min(120px, 100%);
  border: none;
  outline: none;
  background: transparent;
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.highEmphasis};

  &::placeholder {
    color: ${rawColors.text.lowEmphasis};
  }
`;

export const ErrorText = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${rawColors.accent.pink};
`;
